import "./contact-section-styles.scss";

// importing icons
import { AiOutlineContacts } from "react-icons/ai";

// import components
import SectionHeadingComponent from "../../components/section-heading-component/section-heading-component";
import SectionSubHeadingComponent from "../../components/section-sub-heading-component/section-sub-heading-component";
import DividerComponent from "../../components/divider-component/divider-component";
import VerticalDividerComponent from "../../components/vertical-divider-component/vertical-divider-component";
import ContactFormComponent from "../../components/contact-form-component/contact-form-component";

const ContactSection = () => {
	return (
		<section id="contact-section" className="contact-section">
			<div className="contact-section-content-wrapper">
				<SectionSubHeadingComponent
					icon={<AiOutlineContacts />}
					text="Contact Me"
				/>
				<SectionHeadingComponent
					text="Let's have a talk?"
					additional="Say Hello"
				/>

				<DividerComponent />

				<ContactFormComponent />

				<VerticalDividerComponent
					imgSrc={require("../../assets/vertical-divider-black.png")}
				/>
			</div>
		</section>
	);
};

export default ContactSection;
